import Rest from './BaseRest'
import DjangoRest from './DjanoBaseRest'

const resource = 'payments'

export default {
  CreateIntent (id, payload, params) {
    return Rest.post(`${resource}/setup/${id}`, payload, { params })
  },
  FetchPaymentMethods (id) {
    return Rest.get(`${resource}?memberId=${id}`)
  },
  FetchPaymentMethod (id) {
    return Rest.get(`${resource}/${id}`)
  },
  StorePaymentMethod (payload, id) {
    return Rest.post(`${resource}?memberId=${id}`, payload)
  },
  UpdatePaymentMethod (payload, id) {
    return Rest.post(`${resource}/${id}/update-payment-method`, payload)
  },
  DestroyPaymentMethod (id) {
    return Rest.delete(`${resource}/${id}`)
  },
  Refund (payload, id) {
    return Rest.post(`${resource}/accounts/${id}/refund`, payload)
  },
  RefundV2 (payload, id) {
    return DjangoRest.post(`invoice/${id}/refund/`, payload)
  },
  CreateIntentV2 (payload) {
    return DjangoRest.post(`${resource}/setup/`, payload)
  },
  FetchPaymentMethodV2 (id) {
    return DjangoRest.get(`${resource}/${id}`)
  },
  UpdatePaymentMethodV2 (payload, id) {
    return DjangoRest.post(`${resource}/${id}/update/`, payload)
  },
  ApplyCoupon (payload) {
    return DjangoRest.post(`${resource}/apply_coupon/`, payload)
  }
}
